<template>
    <div class="form-group">
        <base-input :error="error">
            <select
                v-model="plan"
                v-validate="'required'"
                name="plan"
                id="plan"
                class="form-control"
            >
                <option :value="null" selected disabled>{{ $t('common.plan') }}</option>
                <option
                    v-for="plan in plans"
                    :key="plan.id"
                    :value="plan.id"
                >{{ plan.translation.name }}</option>
            </select>
        </base-input>
    </div>
</template>

<script>
import BaseInput from "../../argon/components/Inputs/BaseInput";

export default {
    name: "PlanSelect",

    components: {
        BaseInput
    },

    props: {
        items: Array,
        value: Number,
        error: String
    },

    data() {
        return {
            plans: this.items
        };
    },

    computed: {
        plan: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    }
};
</script>